/* file description */

import { message } from "antd";
import { useState } from "react";



export const useModalShow = () => {
  const [showModal, setShowModal] = useState(false);
  const modalContrulor = (isShow: boolean) => () => {
    if(isShow) {
      // if() {
      //   message.warning('请先配置产品品类!');
      //   return ;
      // }
    }
    setShowModal(isShow)
  }
  return {
    showModal,
    modalContrulor,
    setShowModal,
  }
}